import { render, staticRenderFns } from "./Surface.vue?vue&type=template&id=920c14d6&scoped=true"
import script from "./Surface.vue?vue&type=script&lang=js"
export * from "./Surface.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920c14d6",
  null
  
)

export default component.exports